import { Drawer, Button, TextField } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import CheckBox from '../common/CheckBox';
import { useTranslation } from '../../hook/useTranslation';

interface KidCaracterAddDialogProps {
  open: boolean;
  onClose?: () => void;
  inputValue: {
    impression: string;
    physical: string;
    behavior: string;
    isOnlyOne: string;
  };
  setInputValue: React.Dispatch<
    React.SetStateAction<{
      impression: string;
      physical: string;
      behavior: string;
      isOnlyOne: string;
    }>
  >;
  onSubmit: () => void;
}

function KidCaracterAddDialog({
  open,
  onClose = () => {},
  inputValue,
  setInputValue,
  onSubmit,
}: KidCaracterAddDialogProps) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        if (onClose) (onClose as any)(event, reason);
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
    >
      <div className="w-full p-5 min-h-[200px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden">
        <div className="w-full flex justify-between items-center mb-3">
          <div className="w-full text-[20px] font-[700]">{t('upload.character_title')}</div>
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full text-[14px] font-[400] text-[#363636] mb-3">
          {t('upload.character_desc')}
        </div>
        <div className="w-full mb-[12px] relative">
          <div className="text-[14px] font-[400] text-[#363636] mb-[8px]">{t('upload.character_impression')}</div>
          <TextField
            className="text-[12px]"
            variant="outlined"
            value={inputValue.impression}
            onChange={(e) => setInputValue((prev) => ({ ...prev, impression: e.target.value }))}
            fullWidth
            placeholder={t('upload.character_impression_placeholder')}
            size="small"
            disabled={inputValue.isOnlyOne === '단독등장'}
            inputProps={{ maxLength: 26 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-disabled': {
                  backgroundColor: '#f3f3f3',
                  borderColor: '#eaeaea',
                  '& fieldset': {
                    borderColor: '#eaeaea',
                  },
                  '& input': {
                    color: '#c6c6c6',
                    WebkitTextFillColor: '#c6c6c6',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#c6c6c6',
                    opacity: 1,
                  },
                },
              },
            }}
          />
        </div>
        <div className="w-full mb-[12px] relative">
          <div className="text-[14px] font-[400] text-[#363636] mb-[8px]">{t('upload.character_physical')}</div>
          <TextField
            className="text-[12px]"
            variant="outlined"
            value={inputValue.physical}
            onChange={(e) => setInputValue((prev) => ({ ...prev, physical: e.target.value }))}
            fullWidth
            placeholder={t('upload.character_physical_placeholder')}
            size="small"
            disabled={inputValue.isOnlyOne === '단독등장'}
            inputProps={{ maxLength: 26 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-disabled': {
                  backgroundColor: '#f3f3f3',
                  borderColor: '#eaeaea',
                  '& fieldset': {
                    borderColor: '#eaeaea',
                  },
                  '& input': {
                    color: '#c6c6c6',
                    WebkitTextFillColor: '#c6c6c6',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#c6c6c6',
                    opacity: 1,
                  },
                },
              },
            }}
          />
        </div>
        <div className="w-full mb-[12px] relative">
          <div className="text-[14px] font-[400] text-[#363636] mb-[8px]">
            {t('upload.character_behavior')}
          </div>
          <TextField
            className="text-[12px]"
            variant="outlined"
            value={inputValue.behavior}
            onChange={(e) => setInputValue((prev) => ({ ...prev, behavior: e.target.value }))}
            fullWidth
            placeholder={t('upload.character_behavior_placeholder')}
            size="small"
            disabled={inputValue.isOnlyOne === '단독등장'}
            inputProps={{ maxLength: 26 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-disabled': {
                  backgroundColor: '#f3f3f3',
                  borderColor: '#eaeaea',
                  '& fieldset': {
                    borderColor: '#eaeaea',
                  },
                  '& input': {
                    color: '#c6c6c6',
                    WebkitTextFillColor: '#c6c6c6',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#c6c6c6',
                    opacity: 1,
                  },
                },
              },
            }}
          />
        </div>
        <div className="w-full mt-[10px] mb-[30px] relative">
          <CheckBox
            id="kid-caracter-add-dialog-checkbox"
            value={inputValue.isOnlyOne || ''}
            label={t('upload.character_only_one')}
            isChecked={inputValue.isOnlyOne === '단독등장'}
            onChange={(checked) => {
              setInputValue({
                impression: '',
                physical: '',
                behavior: '',
                isOnlyOne: checked ? '단독등장' : '',
              });
            }}
          />
        </div>
        <Button
          variant="contained"
          className="w-full"
          onClick={onSubmit}
          disabled={inputValue.isOnlyOne !== '단독등장' && !!inputValue.impression === false}
        >
          {t('upload.start_diagnosis')}
        </Button>
      </div>
    </Drawer>
  );
}

export default KidCaracterAddDialog;
